import ConversationReadingPaneViewState from '../schema/ConversationReadingPaneViewState';
import { getReadingPaneStore } from '../Store';
/**
 * Selector to get the conversationReadingPaneView State from the store
 */
const getConversationReadingPaneViewState = (): ConversationReadingPaneViewState | null =>
    getReadingPaneStore().conversationReadingPaneViewState;

export default getConversationReadingPaneViewState;
